import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-acd-lists-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfAcdListsIconProps extends SvgIconProps {}

/**
 *
 * @param props -
 * @example
 * @returns
 */
export function CcfAcdListsIcon(props: CcfAcdListsIconProps) {
  return (
    <SvgIcon width="22" height="20" viewBox="0 0 22 20" {...props}>
      <path
        d="M16 1H14V0H12V1H10V0H8V1H6V0H4V1H2C0.9 1 0 1.9 0 3V18C0 19.1 0.9 20 2 20H16C17.1 20 18 19.1 18 18V3C18 1.9 17.1 1 16 1ZM16 18H2V3H4V4H6V3H8V4H10V3H12V4H14V3H16V18Z"
        fill="#FF9400"
      />
      <path d="M4 6H14V8H4V6Z" fill="#FF9400" />
      <path d="M4 10H14V12H4V10Z" fill="#FF9400" />
      <path d="M4 14H14V16H4V14Z" fill="#FF9400" />
    </SvgIcon>
  );
}

export default CcfAcdListsIcon;
